import _extends from "@babel/runtime/helpers/extends";
import { Loader, Modal } from '@wix/design-system';
import { modalsExtension } from '@wix/premium-fed-sdk/@premium-module';
import React from 'react';
// Lazy load the modal to reduce bundle size (includes 290KB SVG)
const LazyNoSitesModal = /*#__PURE__*/React.lazy(() => import('../components/NoSitesModal/NoSitesModal').then(module => ({
  default: module.NoSitesModal
})));
export const StudioModalsExtension = modalsExtension({
  NoSitesModal: props => {
    const {
      onConfirm,
      onCloseButtonClick,
      onLoad,
      ...modalProps
    } = props;
    return /*#__PURE__*/React.createElement(Modal, _extends({}, modalProps, {
      shouldCloseOnOverlayClick: true
    }), /*#__PURE__*/React.createElement(React.Suspense, {
      fallback: /*#__PURE__*/React.createElement(Loader, {
        size: "medium"
      })
    }, /*#__PURE__*/React.createElement(LazyNoSitesModal, {
      onCloseButtonClick: onCloseButtonClick,
      onConfirm: onConfirm,
      onLoad: onLoad
    })));
  }
});
//# sourceMappingURL=studio-modals.extension.js.map